export const createMockCreator =
  <T extends object>(baseMock: T) =>
  (partialMock: Partial<T> = {}): T =>
    Object.assign({}, baseMock, partialMock);
